import { z } from 'zod';
import { SessionStatusSchema } from './status';
import { EmaQuestionnaireSchema } from '../questionnaire';

// If you keep these always defined, put them in Base
const Base = z.object({
  id: z.string().uuid(),
  status: SessionStatusSchema,
  questionnaireId: z.string().uuid(),
  opensAt: z.string().datetime(),
  closesAt: z.string().datetime(),
});

const Future = Base.extend({
  status: z.literal('FUTURE'),
  startedAt: z.undefined(),
  submittedAt: z.undefined(),
});

const Open = Base.extend({
  status: z.literal('OPEN'),
  startedAt: z.undefined(),
  submittedAt: z.undefined(),
});

const Filled = Base.extend({
  status: z.literal('FILLED'),
  startedAt: z.string().datetime(),
  submittedAt: z.string().datetime(),
});

const Missed = Base.extend({
  status: z.literal('MISSED'),
  startedAt: z.undefined(),
  submittedAt: z.undefined(),
});

export const SessionListItemSchema = z.discriminatedUnion('status', [
  Future,
  Open,
  Filled,
  Missed,
]);

export type SessionListItem = z.infer<typeof SessionListItemSchema>;

const withQuestionnaire = z.object({ questionnaire: EmaQuestionnaireSchema });

export const SessionSchema = z.discriminatedUnion('status', [
  Future.merge(withQuestionnaire),
  Open.merge(withQuestionnaire),
  Filled.merge(withQuestionnaire),
  Missed.merge(withQuestionnaire),
]);

export type Session = z.infer<typeof SessionSchema>;

export const SubmitAnswersErrorSchema = z.discriminatedUnion('code', [
  z.object({ code: z.literal('SESSION_NOT_OPEN'), message: z.string() }),
  z.object({ code: z.literal('ALREADY_ANSWERED'), message: z.string() }),
]);

export type SubmitAnswersError = z.infer<typeof SubmitAnswersErrorSchema>;

export const isSubmitAnswersError = (e: unknown): e is SubmitAnswersError =>
  SubmitAnswersErrorSchema.safeParse(e).success;
